import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: {"height":"158px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" })
], -1)
const _hoisted_2 = {
  class: "row",
  style: {"height":"90px"}
}
const _hoisted_3 = { class: "col-1 q-pl-md no-padding q-pl-md" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "row no-padding",
  style: {"height":"50px"}
}, [
  /*#__PURE__*/_createElementVNode("nav", {
    id: "sns-bar",
    class: "Rotis"
  }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", { class: "col no-padding" }, [
        /*#__PURE__*/_createElementVNode("a", {
          id: "sns-facebook",
          href: "http://www.facebook.com/bbraunch",
          title: "Facebook"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "hidden" }, "Facebook")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "col no-padding" }, [
        /*#__PURE__*/_createElementVNode("a", {
          id: "sns-instagram",
          href: "https://www.instagram.com/bbraun_ch/",
          title: "Instagram"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "hidden" }, "Instagram")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "col no-padding" }, [
        /*#__PURE__*/_createElementVNode("a", {
          id: "sns-linkedin",
          href: "https://www.linkedin.com/company/b-braun-group",
          title: "LinkedIn"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "hidden" }, "LinkedIn")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "col no-padding" }, [
        /*#__PURE__*/_createElementVNode("a", {
          id: "sns-xing",
          href: "https://www.xing.com/companies/b.braunmedicalag",
          title: "Xing"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "hidden" }, "Xing")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "col no-padding" }, [
        /*#__PURE__*/_createElementVNode("a", {
          id: "sns-youtube",
          href: "http://www.youtube.ch/bbraunch",
          title: "Youtube"
        }, [
          /*#__PURE__*/_createElementVNode("span", { class: "hidden" }, "Youtube")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = { id: "footer-bar" }
const _hoisted_6 = { class: "row justify-between col" }
const _hoisted_7 = { class: "no-padding" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  class: "no-padding",
  style: {"max-width":"170px"}
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "no-padding" }
const _hoisted_12 = {
  id: "privacy",
  href: "/privacy"
}
const _hoisted_13 = {
  class: "no-padding",
  style: {"min-width":"170px"}
}
const _hoisted_14 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_MainContent = _resolveComponent("MainContent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_MainContent, { class: "bg-accent" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_q_img, {
              src: require('@/assets/bbraun-logo-white.png'),
              "spinner-color": "white",
              style: {"height":"86px","width":"200px"},
              fit: "cover"
            }, null, 8, ["src"])
          ])
        ]),
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_MainContent, null, {
      default: _withCtx(() => [
        _createElementVNode("nav", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", {
              class: _normalizeClass([_ctx.$q.screen.gt.md ? 'col row justify-start' : 'col-12 row justify-center q-mb-md', "col-9 row justify-center"])
            }, [
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("a", {
                  id: "legalnotice",
                  href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/impressum.html'
                }, _toDisplayString(_ctx.$t("Footer.FooterNav.LegalNotice")), 9, _hoisted_8)
              ]),
              _createElementVNode("li", _hoisted_9, [
                _createElementVNode("a", {
                  id: "termsofuse",
                  href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/nutzungsbedingungen.html'
                }, _toDisplayString(_ctx.$t("Footer.FooterNav.TermsOfUse")), 9, _hoisted_10)
              ]),
              _createElementVNode("li", _hoisted_11, [
                _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$t("Footer.FooterNav.Privacy")), 1)
              ]),
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("a", {
                  id: "generalterms",
                  style: {"height":"300px"},
                  href: 'https://www.bbraun.ch/' + (_ctx.$i18n.locale === 'fr' ? 'fr' : 'de') + '/agb.html'
                }, _toDisplayString(_ctx.$t("Footer.FooterNav.GeneralTerms")), 9, _hoisted_14)
              ])
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["text-caption", _ctx.$q.screen.gt.md ? 'row col-3 justify-end' : 'col-12 row justify-center'])
            }, "Copyright © B. Braun Melsungen AG", 2)
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}